var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.331 11.229c.716.426.71 1.12 0 1.542L5.296 21.713C4.58 22.138 4 21.81 4 20.976V3.024c0-.832.586-1.159 1.296-.737z"
})));
export { SvgPlay as ReactComponent };
export default __webpack_public_path__ + "static/media/play.5d78994c.svg";